export interface SendingAuthCodeRequestBody {
    username: string;
    authCode?: string;
};

export interface CheckingAuthCodeRequestBody {
    email: string;
    authCode?: string;
};